import NetworkService from '../services/network.service'

class AddPaymentLinkApi {
  getDetails = async () => {

    let url = `api/payment`;
    let config = {}
    let data = await NetworkService.get(url, config)
    return data && data.data
      ? data.data : data

  };
  putData = async (paymentDetails: any) => {
    let url = "api/payment";
    let response = await NetworkService.put(url, paymentDetails);
    return response && response.data
      ? response.data : response
  }
}

export default AddPaymentLinkApi;